function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useRef, useEffect, useLayoutEffect } from 'react';
import dialogPolyfill from './polyfill';

var NativeDialog = function NativeDialog(_ref) {
  var children = _ref.children,
      exit = _ref.exit,
      showModal = _ref.showModal,
      backdropClickExits = _ref.backdropClickExits,
      dialogProps = _objectWithoutProperties(_ref, ["children", "exit", "showModal", "backdropClickExits"]);

  var dialogRef = useRef(null); // Register dialog with the polyfill if necessary

  useLayoutEffect(function () {
    // The registerDialog function itself determines if the polyfill needs to be applied
    dialogPolyfill.registerDialog(dialogRef.current);
  }); // Open and close the dialog with the appropriate method on mount and unmount

  useEffect(function () {
    var dialogNode = dialogRef.current;
    showModal ? dialogNode.showModal() : dialogNode.show();
    return function () {
      dialogNode.close();
    };
  }, [showModal]); // Bind and unbind event listeners on mount and unmount

  useEffect(function () {
    var dialogNode = dialogRef.current;

    var handleCancel = function handleCancel(event) {
      event.preventDefault();
      exit();
    };

    dialogNode.addEventListener('cancel', handleCancel);

    var handleClick = function handleClick(event) {
      var rect = dialogNode.getBoundingClientRect();
      var isInDialog = rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;

      if (!isInDialog) {
        exit();
      }
    };

    if (backdropClickExits) {
      dialogNode.addEventListener('click', handleClick);
    }

    return function () {
      dialogNode.removeEventListener('cancel', handleCancel);

      if (backdropClickExits) {
        dialogNode.removeEventListener('click', handleClick);
      }
    };
  }, [exit, backdropClickExits]);
  return /*#__PURE__*/React.createElement("dialog", _extends({
    ref: dialogRef
  }, dialogProps), children);
};

export default NativeDialog;